import {Link} from 'react-router-dom';
import {CustomMenu} from '../../../menus/custom-menu';

export function AuthLayoutFooter() {
  const year = new Date().getFullYear();
  return (
    <div className="pt-24 pb-20 flex flex-col sm:flex-row items-center justify-between gap-14 text-xs text-muted mt-auto border-t border-divider w-full">
      <div className="flex items-center gap-10 text-center sm:text-left">
        <img
          src="images/tdmu-logo.svg"
          alt="Trường Đại học Thủ Dầu Một"
          className="h-24 w-auto object-contain flex-shrink-0"
        />
        <span>
          <strong>TDMU.DEV - URL Shortener</strong> © {year} • Phát triển bởi{' '}
          <a
            href="mailto:nguyentanloi@tdmu.edu.vn"
            className="font-bold text-primary hover:underline"
          >
            Nguyễn Tấn Lợi
          </a>
        </span>
      </div>
      <CustomMenu
        menu="auth-page-footer"
        orientation="horizontal"
        itemClassName="hover:text-fg-base transition-colors"
      />
    </div>
  );
}
